import { Button } from "@progress/kendo-react-buttons";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { InputPicker } from "rsuite";
import {
  FormDropDownList,
  FormMaskedTextBox,
  FormMaskedTextBoxMobile,
} from "./formControls";
import countryCodes, { CountryProperty } from "country-codes-list";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Confirm } from "./confirm";
import { Alert } from "./alert";
import { Error } from "@progress/kendo-react-labels";
// import Account from "../../../../apps/tenant/src/utils/apiConfig";

export interface NewUserProps {
  submitAdminUser: (data: any) => void;
  dataGridItem?: any;
  formType?: any;
  formTypeFunction: Function;
  newUserState: Function;
  adminUserState: Function;
  saveDialogFunction: Function;
  saveDialog: any;
  phNoFunction: Function;
  phNo?: string;
  pageType?: string;
  accntId?: string;
}
export function NewUser(props: NewUserProps) {
  console.log("just checking in new user");
  const [finalCountryCode, setFinalCountryCode] = useState<any>();
  const [errors, setErrors] = useState<any>({});
  console.log("save dialog", props.saveDialog);
  console.log("save");
  console.log("form type print in new user", props.formType);

  console.log("I am inside new user type");

  async function signIn(formData: { [name: string]: any }) {
    console.log("submit admin user in sing in of new user", formData);
    if (props.formType === "NEW") {
      console.log("save clicked");
    } else if (props.formType === "EDIT") {
      console.log("update clicked");
    }

    const countryCodeIndex = countryCode?.lastIndexOf(":");
    const countryCodeNumber = countryCode
      ?.substring(countryCodeIndex + 1)
      ?.trim();

    setFinalCountryCode(countryCodeNumber);

    console.log("inside new user signin");
    let data: any = {};
    data["fname"] = formData["fname"];
    data["lname"] = formData["lname"];
    data.email = formData["email"];

    data.phNo =
      (countryCodeNumber && countryCodeNumber + formData["phNo"]) ||
      formData["phNo"];

    data.role = formData["role"];
    data.status = formData["status"];

    if (
      props.formType === "NEW" &&
      !countryCodeNumber &&
      formData["phNo"]?.trim()
    ) {
      console.log("inside undefined of country code");
      let err: any = {};
      err.noCountryCode = {
        error: intl.formatMessage({ id: "users.createUser.countryCode" }),
      };
      setErrors(err);

      return false;
    }

    console.log("log the form data role", formData["roleDesc"]);
    console.log("hello in signin");
    console.log("Submit admin user data phNo", data.phNo);
    props.submitAdminUser(data);
    // props.newDataFunction(data)
    console.log("data is", data);
    props.phNoFunction(data.phNo);
  }
  const [formKey, setFormKey] = useState(1);
  // const nameRegex = new RegExp(/^[a-zA-Z\s.]+$/);
  const nameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&\-#()]+$/);
  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
  const mobileRegex: RegExp = new RegExp(/^[0-9]{5,15}$/);
  const mobileRegexUpdate: RegExp = /^(\+[0-9]{5,20})$/;

  const [countryCode, setCountryCode] = useState<any>();
  const [showNewUser, setShowNewUser] = useState<any>({});
  const [showtoggle, settoggle] = useState(false);

  console.log("show new user data in new user", showNewUser);
  // const allCountryList = countryCodes?.customList(
  //   CountryProperty?.countryNameEn
  // );
  const allCountryList = countryCodes?.customList("countryNameEn");
  const allCountries = Object.entries(allCountryList).map(
    ([key, value]) => value
  );
  const countryNameList = allCountries.map((countryString) => {
    const countryName = countryString.replace(/\s*\([^)]*\)/, "").trim();
    return countryName;
  });

  const intl = useIntl();

  console.log("form type in new user", props.formType);
  console.log("admin user state", props.adminUserState);

  // const countries = [
  //   { label: "India", value: "+91", code: "in" },
  //   { label: "Singapore", value: "+65", code: "sg" },
  //   { label: "Malaysia", value: "+60", code: "my" },
  // ];

  // const myCountryCodesObject = countryCodes?.customList(
  //   CountryProperty?.countryCode,
  //   "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
  // );

  const myCountryCodesObject = countryCodes?.customList(
    "countryCode",
    "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
  );
  const myCountryCodesArray = Object.entries(myCountryCodesObject).map(
    ([key, value]) => value
  );

  const extractedData = myCountryCodesArray.map((item: any) => {
    const [countryCodeSome, rest] = item.split("]");
    const [countryNameEn, countryCallingCode] = rest.split(": +");

    return {
      countryCode: countryCodeSome.slice(1),
      countryNameEn,
      item,
      countryCallingCode: `+${countryCallingCode}`,
    };
  });

  const countryList = extractedData.map((item) => {
    return {
      label: item.item,
      value: item.item,
      code: item.countryCode.toLowerCase(),
      countryName: item.countryNameEn,
      countryCallingCode: item.countryCallingCode,
    };
  });

  console.log("extracted data", extractedData);

  console.log("country code list phone", myCountryCodesObject);

  useEffect(() => {
    console.log("New User", props.formType);
    if (props.dataGridItem.dataItem && props.formType === "EDIT") {
      const role = props?.dataGridItem?.dataItem?.role;
      let roleName;

      switch (role) {
        case "tnt_courseScheduler":
          roleName = intl.formatMessage({ id: "organization.courseScheduler" });
          break;
        case "tnt_superAdmin":
          roleName = intl.formatMessage({ id: "organization.superAdmin" });
          break;
        case "tnt_reviewer":
          roleName = intl.formatMessage({ id: "organization.reviewer" });
          break;
        case "tnt_contentCreator":
          roleName = intl.formatMessage({ id: "organization.contentCreator" });
          break;
        case "tnt_admin":
          roleName = intl.formatMessage({ id: "organization.admin" });
          break;
        case "tnt_auditor":
          roleName = intl.formatMessage({ id: "organization.auditor" });
          break;
        default:
          break;
      }

      if (roleName !== undefined) {
        props.dataGridItem.dataItem.role = roleName;
      }

      settoggle(true);

      setShowNewUser(props.dataGridItem.dataItem);
    } else if (props.formType === "NEW") {
      settoggle(true);
    }
  }, [props.dataGridItem]);

  const navigate = useNavigate();

  const handleCancelClick = () => {
    console.log("inside handle cancel");
    setTimeout(() => {
      const tabButtons = document.querySelectorAll("button");
      const adminUserTab = Array.from(tabButtons).find(
        (btn) => btn.textContent?.includes(intl.formatMessage({ id: "organization.adminUserTab" })) // match your tab's label exactly
      );
      adminUserTab?.click(); //  simulate tab switch
    }, 100);
  };

  const validators = {
    mobileNumberValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.mobileNumberValidation" })
        : mobileRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "organization.user.createUser.mobileNumberValidation",
          }),
    mobileNumberUpdateValidator: (value: string) =>
      !value
        ? `${intl.formatMessage({ id: "organization.mobileNumberValidation" })}`
        : mobileRegexUpdate.test(value)
        ? ""
        : intl.formatMessage({
            id: `${intl.formatMessage({
              id: "organization.mobileNumberAnotherValidation",
            })}`,
          }),
    firstNameValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.fnameValidation" })
        : nameRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "user.createUser.fnameAnotherValidation" }),
    lastNameValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.lnameValidation" })
        : nameRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "user.createUser.lnameAnotherValidation" }),
    emailValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.emailValidation" })
        : emailRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.emailAnotherValidation" }),
    role: (value: string) =>
      !value
        ? intl.formatMessage({ id: "newUser.dropdownRoleValidation" })
        : "",
    statusValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "newUser.dropdownStatusValidation" })
        : "",
  };
  return (
    <div>
      {/* <div className="mb-10"></div> */}
      <div className="text-mk-primary-bright text-xl font-bold">
        <div className="pb-2"></div>
        {props.formType === "EDIT" ? (
          <FormattedMessage id="organization.exixtingUserDetails" />
        ) : (
          <FormattedMessage id="organization.newUser" />
        )}
      </div>
      {props.formType === "NEW"
        ? // saveDialog &&
          props.saveDialog &&
          props.pageType === "tenant" && (
            <Dialog className="confirmSuccessDialogue">
              <Confirm
                description={`${intl.formatMessage({
                  id: "users.createUser.newUser",
                })}`}
                successText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                failureText={`${intl.formatMessage({
                  id: "users.createUser.anotherUser",
                })}`}
                icon={"/successShape.png"}
                iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
                backgroundColor={"mk-bright-green"}
                onSuccess={() => {
                  props.adminUserState(true);
                  props.newUserState(false);
                  props.saveDialogFunction(false);
                }}
                onFailure={() => {
                  props.saveDialogFunction();
                  setFormKey(formKey + 1);
                  setErrors({});
                  setCountryCode("");
                }}
              />
            </Dialog>
          )
        : // saveDialog &&
          props.saveDialog &&
          props.pageType === "tenant" && (
            <Dialog className="confirmSuccessDialogue">
              <Alert
                description={`${intl.formatMessage({
                  id: "users.createUser.updateUser",
                })}`}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"/successShape.png"}
                iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
                backgroundColor={"mk-bright-green"}
                onClick={() => {
                  props.adminUserState(true);
                  props.newUserState(false);
                  props.formTypeFunction(false);
                  props.saveDialogFunction(false);
                }}
              />
            </Dialog>
          )}

      <div className="mt-2">
        {showtoggle && (
          <Form
            initialValues={showNewUser}
            onSubmit={signIn}
            key={formKey}
            render={(formRenderProps) => (
              <FormElement>
                <div className="grid grid-cols-2">
                  <div>
                    <div>
                      <Field
                        name={"fname"}
                        id={"fname"}
                        label={intl.formatMessage({
                          id: "newUser.firstName",
                        })}
                        component={FormMaskedTextBox}
                        validator={validators.firstNameValidator}
                        className="bg-white w-96"
                        maxLength={50}
                      />
                    </div>
                    <Field
                      name={"email"}
                      id={"email"}
                      label={intl.formatMessage({
                        id: "newUser.email",
                      })}
                      value={props.dataGridItem.email}
                      component={FormMaskedTextBox}
                      validator={validators.emailValidator}
                      className="bg-white w-96"
                      maxLength={50}
                    />
                    <div>
                      <Field
                        name={"role"}
                        id={"role"}
                        label={intl.formatMessage({
                          id: "newUser.role",
                        })}
                        component={FormDropDownList}
                        className="bg-white w-96"
                        validator={validators.role}
                        data={[
                          intl.formatMessage({ id: "organization.superAdmin" }),
                          intl.formatMessage({
                            id: "organization.contentCreator",
                          }),
                          intl.formatMessage({ id: "organization.reviewer" }),
                          intl.formatMessage({
                            id: "organization.courseScheduler",
                          }),
                          intl.formatMessage({ id: "organization.admin" }),
                          intl.formatMessage({ id: "organization.auditor" }),
                        ]}
                      />
                    </div>
                  </div>

                  <div>
                    <div>
                      <Field
                        name={"lname"}
                        id={"lname"}
                        label={intl.formatMessage({
                          id: "newUser.lastName",
                        })}
                        // value={value}
                        value={props.dataGridItem.lname}
                        // component={FormInput}
                        component={FormMaskedTextBox}
                        validator={validators.lastNameValidator}
                        className="bg-white w-96"
                        maxLength={50}
                      />
                    </div>

                    {props.formType === "NEW" ? (
                      <div>
                        <div className="flex items-end">
                          <InputPicker
                            cleanable={false}
                            size="sm"
                            // style={{ width: 102 }}
                            style={{
                              width: 102,
                              display: "inline-block",
                              border: "1px solid var(--color-mk-primary)",
                              borderRadius: "4px",
                            }}
                            className="bg-white w-96"
                            onChange={setCountryCode}
                            // defaultValue={countryCode}
                            data={countryList}
                            renderValue={(value, item: any) => {
                              console.log("value inside render value", value);
                              console.log("item code", item.code);
                              return (
                                <div className="bg-white w-96">
                                  <span
                                    className={`fi fi-${item?.code}`}
                                  ></span>
                                  {/* &nbsp;{value} */}
                                  {item?.countryCallingCode}
                                </div>
                              );
                            }}
                            renderMenuItem={(label, item) => {
                              console.log("print label", label);
                              return (
                                <div>
                                  <span
                                    className={`fi fi-${item?.code}`}
                                  ></span>
                                  {/* &nbsp;{`${label} (${item?.value})`} */}
                                  {`${item?.countryName} (${item?.countryCallingCode})`}
                                </div>
                              );
                            }}
                          />

                          <Field
                            name={"phNo"}
                            id={"phNo"}
                            label={intl.formatMessage({
                              id: "newUser.mobileNum",
                            })}
                            maxLength={15}
                            component={FormMaskedTextBoxMobile}
                            validator={validators.mobileNumberValidator}
                            className="bg-white w-72"
                          />
                        </div>
                        <Error>{errors.noCountryCode?.error}</Error>
                      </div>
                    ) : (
                      <Field
                        name={"phNo"}
                        id={"phNo"}
                        label={intl.formatMessage({
                          id: "newUser.mobileNum",
                        })}
                        maxLength={15}
                        component={FormMaskedTextBox}
                        validator={validators.mobileNumberUpdateValidator}
                        className="bg-white w-96"
                      />
                    )}

                    <div>
                      <Field
                        name={"status"}
                        id={"status"}
                        label={intl.formatMessage({
                          id: "newUser.status",
                        })}
                        component={FormDropDownList}
                        className="bg-white w-40"
                        data={["Enabled", "Disabled"]}
                        validator={validators.statusValidator}
                      />
                    </div>

                    <div className="flex gap-4 mt-4">
                      <Button
                        className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                        hover:text-black focus:outline-none px-4 py-2"
                      >
                        {props.formType === "NEW" ? (
                          <FormattedMessage id="user.createUser.submit"></FormattedMessage>
                        ) : (
                          <FormattedMessage id="user.createUser.update"></FormattedMessage>
                        )}
                      </Button>
                      <Button
                        type="button"
                        key={formKey}
                        onClick={handleCancelClick}
                        className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey

                  hover:text-black focus:outline-none px-4 py-2"
                      >
                        <FormattedMessage id="newUser.cancel" />
                      </Button>
                    </div>
                  </div>
                </div>
              </FormElement>
            )}
          />
        )}
      </div>
    </div>
  );
}
